// import { Card, Col, Row, Typography } from "antd";
import { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import Echart from "../../UserPanel/components/chart/EChart";
// import LineChart from "../../UserPanel/components/chart/LineChart";
import "../../../src/UserPanel/assets/styles/main.css";
import "../../../src/UserPanel/assets/styles/responsive.css";
import MUIDataTable from "mui-datatables";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { PostApi, getApiWithToken } from "../../Helper/helper";
// import { getApiWithToken } from "../../Helper/helper";
import StripeCheckout from 'react-stripe-checkout';
// import { PostApi } from "../../Helper/helper";
// import { getApiWithToken } from "../../Helper/helper";



import BaseUrl from '../../BaseUrl/index'
import Swal from "sweetalert2";
// import { Loader } from "react-overlay-loader"
import 'react-overlay-loader/styles.css';

const Home = () => {
  const [idc] = useState(localStorage.getItem("id"));
  console.log(idc, 'lllll')
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const back =()=>{
    setShow(false)
    console.log('minhaj')
}
  // const { Title } = Typography;
  // jjjj

  // const navigate = useNavigate();

  useEffect(() => {
    setShow(true)
    getData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])

  const [datas, setdatas] =useState([])


  const getData = () => {
    // setLoader(true);
    getApiWithToken(`${BaseUrl.baseUrl}customer/package/view`, "", userData)
      .then(({ data }) => {
        console.log("mmmmmmmmmmmmmmmmmmmmm", data.data);
        setdatas(data.data);

        // setName(data.name);
        // setEmail(data.email);
        // setProfileImage(data.picture);
        // setLoader(false);
      })
      .catch((err) => {
        console.log("err---------", err);
      });
  };

  // const dollor = [
  //   <svg
  //     width="22"
  //     height="22"
  //     viewBox="0 0 20 20"
  //     fill="none"
  //     xmlns="http://www.w3.org/2000/svg"
  //     key={0}
  //   >
  //     <path
  //       d="M8.43338 7.41784C8.58818 7.31464 8.77939 7.2224 9 7.15101L9.00001 8.84899C8.77939 8.7776 8.58818 8.68536 8.43338 8.58216C8.06927 8.33942 8 8.1139 8 8C8 7.8861 8.06927 7.66058 8.43338 7.41784Z"
  //       fill="#fff"
  //     ></path>
  //     <path
  //       d="M11 12.849L11 11.151C11.2206 11.2224 11.4118 11.3146 11.5666 11.4178C11.9308 11.6606 12 11.8861 12 12C12 12.1139 11.9308 12.3394 11.5666 12.5822C11.4118 12.6854 11.2206 12.7776 11 12.849Z"
  //       fill="#fff"
  //     ></path>
  //     <path
  //       fillRule="evenodd"
  //       clipRule="evenodd"
  //       d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM11 5C11 4.44772 10.5523 4 10 4C9.44772 4 9 4.44772 9 5V5.09199C8.3784 5.20873 7.80348 5.43407 7.32398 5.75374C6.6023 6.23485 6 7.00933 6 8C6 8.99067 6.6023 9.76515 7.32398 10.2463C7.80348 10.5659 8.37841 10.7913 9.00001 10.908L9.00002 12.8492C8.60902 12.7223 8.31917 12.5319 8.15667 12.3446C7.79471 11.9275 7.16313 11.8827 6.74599 12.2447C6.32885 12.6067 6.28411 13.2382 6.64607 13.6554C7.20855 14.3036 8.05956 14.7308 9 14.9076L9 15C8.99999 15.5523 9.44769 16 9.99998 16C10.5523 16 11 15.5523 11 15L11 14.908C11.6216 14.7913 12.1965 14.5659 12.676 14.2463C13.3977 13.7651 14 12.9907 14 12C14 11.0093 13.3977 10.2348 12.676 9.75373C12.1965 9.43407 11.6216 9.20873 11 9.09199L11 7.15075C11.391 7.27771 11.6808 7.4681 11.8434 7.65538C12.2053 8.07252 12.8369 8.11726 13.254 7.7553C13.6712 7.39335 13.7159 6.76176 13.354 6.34462C12.7915 5.69637 11.9405 5.26915 11 5.09236V5Z"
  //       fill="#fff"
  //     ></path>
  //   </svg>,
  // ];
  // const profile = [
  //   <svg
  //     width="22"
  //     height="22"
  //     viewBox="0 0 20 20"
  //     fill="none"
  //     xmlns="http://www.w3.org/2000/svg"
  //     key={0}
  //   >
  //     <path
  //       d="M9 6C9 7.65685 7.65685 9 6 9C4.34315 9 3 7.65685 3 6C3 4.34315 4.34315 3 6 3C7.65685 3 9 4.34315 9 6Z"
  //       fill="#fff"
  //     ></path>
  //     <path
  //       d="M17 6C17 7.65685 15.6569 9 14 9C12.3431 9 11 7.65685 11 6C11 4.34315 12.3431 3 14 3C15.6569 3 17 4.34315 17 6Z"
  //       fill="#fff"
  //     ></path>
  //     <path
  //       d="M12.9291 17C12.9758 16.6734 13 16.3395 13 16C13 14.3648 12.4393 12.8606 11.4998 11.6691C12.2352 11.2435 13.0892 11 14 11C16.7614 11 19 13.2386 19 16V17H12.9291Z"
  //       fill="#fff"
  //     ></path>
  //     <path
  //       d="M6 11C8.76142 11 11 13.2386 11 16V17H1V16C1 13.2386 3.23858 11 6 11Z"
  //       fill="#fff"
  //     ></path>
  //   </svg>,
  // ];
  // const heart = [
  //   <svg
  //     width="22"
  //     height="22"
  //     viewBox="0 0 20 20"
  //     fill="none"
  //     xmlns="http://www.w3.org/2000/svg"
  //     key={0}
  //   >
  //     <path
  //       fillRule="evenodd"
  //       clipRule="evenodd"
  //       d="M3.17157 5.17157C4.73367 3.60948 7.26633 3.60948 8.82843 5.17157L10 6.34315L11.1716 5.17157C12.7337 3.60948 15.2663 3.60948 16.8284 5.17157C18.3905 6.73367 18.3905 9.26633 16.8284 10.8284L10 17.6569L3.17157 10.8284C1.60948 9.26633 1.60948 6.73367 3.17157 5.17157Z"
  //       fill="#fff"
  //     ></path>
  //   </svg>,
  // ];
  // const cart = [
  //   <svg
  //     width="22"
  //     height="22"
  //     viewBox="0 0 20 20"
  //     fill="none"
  //     xmlns="http://www.w3.org/2000/svg"
  //     key={0}
  //   >
  //     <path
  //       fillRule="evenodd"
  //       clipRule="evenodd"
  //       d="M10 2C7.79086 2 6 3.79086 6 6V7H5C4.49046 7 4.06239 7.38314 4.00612 7.88957L3.00612 16.8896C2.97471 17.1723 3.06518 17.455 3.25488 17.6669C3.44458 17.8789 3.71556 18 4 18H16C16.2844 18 16.5554 17.8789 16.7451 17.6669C16.9348 17.455 17.0253 17.1723 16.9939 16.8896L15.9939 7.88957C15.9376 7.38314 15.5096 7 15 7H14V6C14 3.79086 12.2091 2 10 2ZM12 7V6C12 4.89543 11.1046 4 10 4C8.89543 4 8 4.89543 8 6V7H12ZM6 10C6 9.44772 6.44772 9 7 9C7.55228 9 8 9.44772 8 10C8 10.5523 7.55228 11 7 11C6.44772 11 6 10.5523 6 10ZM13 9C12.4477 9 12 9.44772 12 10C12 10.5523 12.4477 11 13 11C13.5523 11 14 10.5523 14 10C14 9.44772 13.5523 9 13 9Z"
  //       fill="#fff"
  //     ></path>
  //   </svg>,
  // ];
  // const count = [
  //   {
  //     today: "Today’s Sales",
  //     title: "$53,000",
  //     persent: "+30%",
  //     icon: dollor,
  //     bnb: "bnb2",
  //   },
  //   {
  //     today: "Today’s Users",
  //     title: "3,200",
  //     persent: "+20%",
  //     icon: profile,
  //     bnb: "bnb2",
  //   },
  //   {
  //     today: "New Clients",
  //     title: "+1,200",
  //     persent: "-20%",
  //     icon: heart,
  //     bnb: "redtext",
  //   },
  //   {
  //     today: "New Orders",
  //     title: "$13,200",
  //     persent: "10%",
  //     icon: cart,
  //     bnb: "bnb2",
  //   },
  // ];

  // data table
  const [show2, setShow2] = useState(false);
  const handleClose2 = () => setShow2(false);
  const back2 = () => {
    setShow2(false);
    setShow2(false);
  };
  const [pay, setpay] = useState()
  const amounts = parseInt(pay)
  // const pays = parseInt(pay);
  // console.log(pays,'mmmm>');
  // console.log(pay, 'kkk')
  const modal = (pmn) => {
    setpay(pmn)
  
    setShow2(true);
    setShow(false);
    }

  const columns = [
    {
      name: "date",
      label: "Date",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "id",
      label: "Reference Id",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "tin",
      label: "Tin",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "name",
      label: "Name",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "Amount ($)",
      label: "Amount ($)",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "Form Type",
      label: "Form Type",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "Is Corrected",
      label: "Is Corrected",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "Form Count",
      label: "Form Count",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "Schedule Date",
      label: "Schedule Date",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "Actions",
      label: "Actions",
      options: {
        filter: true,
        sort: true,
      },
    },
    // {
    //   name: "company",
    //   label: "Company",
    //   options: {
    //     filter: true,
    //     sort: false,
    //   },
    // },
    // {
    //   name: "city",
    //   label: "City",
    //   options: {
    //     filter: true,
    //     sort: false,
    //   },
    // },
    // {
    //   name: "state",
    //   label: "State",
    //   options: {
    //     filter: true,
    //     sort: false,
    //   },
    // },
  ];

  const data = [
    // { name: "Joe James", company: "Test Corp", city: "Yonkers", state: "NY" },
    // { name: "John Walsh", company: "Test Corp", city: "Hartford", state: "CT" },
    // { name: "Bob Herm", company: "Test Corp", city: "Tampa", state: "FL" },
    // {
    //   name: "James Houston",
    //   company: "Test Corp",
    //   city: "Dallas",
    //   state: "TX",
    // },
  ];

  const options = {
    filterType: "checkbox",
  };
  const [userData] = useState(localStorage.getItem("token"));
  const stripePayfunc = (token1) => {
    setShow2(false);
    console.log('packageId,',idc)
    const formData = new FormData();
  formData.append("customer_id",idc );
  formData.append("source", token1.id);
  formData.append("amount", amounts);
PostApi(`${BaseUrl.baseUrl}customer/payment`,formData,userData)
.then((data)=>{console.log('data=====',data)
Swal.fire({
    title: "success",
    text: data.data.message,
    icon: "success",
    confirmButtonColor: "#29BF12",
    timer: 1500,
  });




})



.catch((err)=>{console.log('errr',err);})
 
  // fetch(`${BaseUrl.baseUrl}user/subscriptions`, {
  //   method: 'POST',
  //   body: JSON.stringify(token),
  // }).then(response => {
  //   response.json().then(data => {
  //     alert(`We are in business, ${data.email}`);
  //   });
  // });

}

  return (
    <>
     <Modal
        show={show2}
       
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={handleClose2}
      >
        {/* <Modal.Header closeButton> */}
        <Modal.Header style={{background: "linear-gradient(#141e30, #243b55)"}}>
          {/* <i className='fa fa-close'>baloch</i>
                    <AiFillCloseCircle fontSize={20} /> */}
          <Modal.Title style={{background: "linear-gradient(#141e30, #243b55)"}}> </Modal.Title>
          {/* <AiFillCloseCircle onClick={handleClose} style={{ marginLeft: "190", cursor: "pointer" }} fontSize={40} /> */}
        </Modal.Header >
        <Modal.Body style={{background: "linear-gradient(#141e30, #243b55)"}}>
        <div class="col-sm-12 d-flex justify-content-center">
    <div class="card" style={{boxShadow: 'rgba(50, 50, 93, 0.25) 0px 30px 60px -12px, rgba(0, 0, 0, 0.3) 0px 18px 36px -18px', background:'#0000' }}>
      <div class="card-body">
        <h1 style={{fontSize:'20px', textAlign:'left',fontWeight:'bold', color:'#fff'}}>One-Year Membership Fee</h1>
        <p style={{fontSize:'20px', textAlign:'center',fontWeight:'200', color:'#fff'}}>Enterprise X 1</p>
        <p style={{fontSize:'15px', textAlign:'center',fontWeight:'200', color:'#fff'}}>Estimated Tax :<span style={{fontWeight:'bold'}}>$ 0.00</span></p>
        <p style={{fontSize:'15px', textAlign:'center',fontWeight:'200', color:'#fff'}}>Filing Fee :<span style={{fontWeight:'bold'}}>${amounts}</span></p>
        <p style={{fontSize:'15px', textAlign:'center',fontWeight:'200', color:'#fff'}}>Prepay balance :<span style={{fontWeight:'bold'}}>$ 0.00</span></p>
      <h1 style={{fontSize:'20px', textAlign:'center',fontWeight:'bold', color:'#fff'}}>${amounts} </h1>
           <div className="d-flex justify-content-center">
        <StripeCheckout
      
      amount={amounts*100}
        token={stripePayfunc}
        stripeKey="pk_test_51IIZO8Kp3j5Y1UYUhdopZryeRKjlRqEcw4rrDhwELKCRDjRSOJtSXicia6jkN63CyflKvQwej7SqGt1MZ6UwKgfz00ipRMArG9"
      />
      </div>
      </div>
      </div>
      </div>
          {/* <div className="col-lg-12  ">
           <h1 style={{fontSize:'30px', textAlign:'center',fontWeight:'bold'}}>${amounts} </h1>
           <div className="d-flex justify-content-center">
        <StripeCheckout
      
      amount={amounts*100}
        token={stripePayfunc}
        stripeKey="pk_test_51IIZO8Kp3j5Y1UYUhdopZryeRKjlRqEcw4rrDhwELKCRDjRSOJtSXicia6jkN63CyflKvQwej7SqGt1MZ6UwKgfz00ipRMArG9"
      />
      </div>
      </div> */}
          
         
        </Modal.Body>

        <Modal.Footer style={{background: "linear-gradient(#141e30, #243b55)"}}>
         
          <Button
            className="btn btn-primary"
            onClick={back2}
            style={{ boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px" }}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <div className="layout-content">
        <h2>Dashboard</h2>
        <Modal 
      show={show} 
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      onHide={handleClose}>
                {/* <Modal.Header closeButton> */}
                <Modal.Header  style={{background: "linear-gradient(#141e30, #243b55)"}} >
                    {/* <i className='fa fa-close'>baloch</i>
                    <AiFillCloseCircle fontSize={20} /> */}
                    <Modal.Title style={{color:'#fff'}}> Select Plan</Modal.Title>
                    {/* <AiFillCloseCircle onClick={handleClose} style={{ marginLeft: "190", cursor: "pointer" }} fontSize={40} /> */}

                </Modal.Header >
                <Modal.Body  style={{background: "linear-gradient(#141e30, #243b55)"}}>
                  <div className="row">

                    {datas.map((v, index) => {
            
          return ( 
                    <div className="col-lg-3" style={{
                      boxShadow: 'rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px 20px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset',
                      margin:'10PX',
                      padding:'10px',
                      }}>
                 
                      <h5 style={{color:'#fff'}}>
                      {v.package_name}
                      <br/>
                      <span style={{fontSize:'18px', fontWeight:'500', color:'#fff'}}>${v.amount}</span>
                      </h5>
                       {/* <li style={{color:'#fff'}}>${v.amount}/ YEAR + {v.package_name}</li>
                        <li style={{color:'#fff'}}>Everything from Essential e-File.</li>
                        <li style={{color:'#fff'}}>Perfect for accountants and CPA firms.</li>
                        <br/> */}
                        <button className="btn btn-primary" style={{border:'none',borderRadius: 'inherit',backgroundColor:"#0D0A0B", marginTop:'10px'}}  onClick={()=>{modal(v.amount) }}>PAY & CONTINUE</button>

                    </div>
                    );
                  })} 
                    
                    
                    {/* <div className="col-lg-4">
                    <ul style={{listStyleType: 'disc'}}>
                      <h4 style={{color:'#fff'}}>
                      E-FILE PLUS
                      <br/>
                      <span style={{fontSize:'18px', fontWeight:'500', color:'#fff'}}>Compliance</span>
                      </h4>
                       <li style={{color:'#fff'}}>$249/ YEAR + PER E-FILE</li>
                        <li style={{color:'#fff'}}>Everything from Essential e-File.</li>
                        <li style={{color:'#fff'}}>Perfect for accountants and CPA firms.</li>
                        <br/>
                        <button className="btn btn-primary" style={{border:'none',borderRadius: 'inherit',backgroundColor:"#0D0A0B"}}  onClick={()=>{modal('249') }}>PAY & CONTINUE</button>
                       
                      </ul>
                    </div>
                    <div className="col-lg-4">
                    <ul style={{listStyleType: 'disc'}}>
                      <h4 style={{color:'#fff'}}>
                      ENTERPRISE 
                      <br/>
                      <span style={{fontSize:'18px', fontWeight:'500', color:'#fff'}}>e-file</span>
                      </h4>
                       <li style={{color:'#fff'}}>$349/ YEAR + PER E-FILE</li>
                        <li style={{color:'#fff'}}>Everything from previous tiers.</li>
                        <li style={{color:'#fff'}}>Rights & User Management.</li>
                        <li style={{color:'#fff'}}>Perfect for large firms and enterprises</li>
                        <button className="btn btn-primary" style={{border:'none',borderRadius: 'inherit',backgroundColor:"#0D0A0B"}}  onClick={()=>{modal('349') }}>PAY & CONTINUE</button>
                       
                      </ul>
                    </div> */}
           

                    
                    




                  </div>



                </Modal.Body>
                
                <Modal.Footer  style={{background: "linear-gradient(#141e30, #243b55)"}}>
               
                    <Button  className="btn btn-primary" onClick={back} style={{boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',backgroundColor:"#0D0A0B"}}>
                        Close
                    </Button>
                    {/* <Button variant="primary" onClick={addcustomer}>
                        Add
                    </Button> */}
                </Modal.Footer>
            </Modal>

        <p className="fs-6 mt-2">
          <span className="text-danger"> Note:</span> If you have filed form(s)
          directly to a State (not via the Combined Federal/State Filing
          program), you may need to file a Reconciliation form to accompany{" "}
          <br /> the State form(s). To file a Reconciliation form, go to Forms
          &gt; File Reconciliation Form.
        </p>

        <div class="row mt-4">
          <div class="col-sm-12 col-md-6 col-lg-2 mt-2 mt-md-0">
            <input
              className="form-control"
              placeholder="Type TIN or Part of name or client ID"
              type="text"
            />
          </div>
          <div class="col-sm-12 col-md-6 col-lg-2 mt-2 mt-md-0">
            <select className="form-control">
              <option value="">All statuses</option>
              <option value="0">Not submitted</option>
              <option value="1,2,3,6,7,9">Submitted</option>
              <option value="4">IRS Accepted</option>
              <option value="5">Blocked</option>
              <option value="8,10">Resubmit</option>
              <option value="20">InQueue</option>
              <option value="21">OnlyStateSubmitted</option>
            </select>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-2 mt-2 mt-md-0">
            <select className="form-control" name="filter">
              <option value="2023">2023</option>
              <option selected="selected" value="2022">
                2022
              </option>
              <option value="2021">2021</option>
              <option value="2020">2020</option>
            </select>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-2 mt-2 mt-md-0">
            <input
              className="form-control"
              type="text"
              placeholder="Type Reference number"
            />
          </div>
          <div class="col-sm-12 col-md-6 col-lg-2 mt-2 mt-md-0">
            <button className="btn btn-primary" style={{background: "linear-gradient(#141e30, #243b55)"}}>Start New Filing</button>
          </div>
        </div>

        <div className="container">
          <div className="row mt-5">
            <MUIDataTable
              // title={"Employee List"}
              data={data}
              columns={columns}
              options={options}
            />
          </div>
        </div>

        {/* <Row className="rowgap-vbox" gutter={[24, 0]}>
          {count.map((c, index) => (
            <Col
              key={index}
              xs={24}
              sm={24}
              md={12}
              lg={6}
              xl={6}
              className="mb-24"
            >
              <Card bordered={false} className="criclebox ">
                <div className="number">
                  <Row align="middle" gutter={[24, 0]}>
                    <Col xs={18}>
                      <span>{c.today}</span>
                      <Title level={3}>
                        {c.title} <small className={c.bnb}>{c.persent}</small>
                      </Title>
                    </Col>
                    <Col xs={6}>
                      <div className="icon-box">{c.icon}</div>
                    </Col>
                  </Row>
                </div>
              </Card>
            </Col>
          ))}
        </Row>

        <Row gutter={[24, 0]}>
          <Col xs={24} sm={24} md={12} lg={12} xl={10} className="mb-24">
            <Card bordered={false} className="criclebox h-full">
              <Echart />
            </Card>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={14} className="mb-24">
            <Card bordered={false} className="criclebox h-full">
              <LineChart />
            </Card>
          </Col>
        </Row> */}
      </div>
    </>
  );
};

export default Home;
// minhaj
// minhaj
// minhaj
// minhaj
// minhaj
// minhaj